import React, { useState, useEffect } from "react";
import { Grid, Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavbarLoggedInNew from "components/Navbar-new/NavbarLoggedInNew";
import MenteeCardList from "./MenteeCards";
import MenteeDashboardCard from "./MenteeDashboardCard";
import { useSelector, useDispatch } from "react-redux";
import { setOnboardingData } from '../Homepage/OnboardingActions';
import { baseURL } from "../aws-config";
import api from '../api';
import Loader from '../components/Loader';

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state.userProfile);
  const userRole = userProfile?.data?.role;
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const accessToken = localStorage.getItem('access_token');

  useEffect(() => {
    const checkOnboardingStatus = async () => {
      try {
        // First check localStorage for cached onboarding data
        const cachedOnboarding = localStorage.getItem('onboardingData');
        let onboardingData = cachedOnboarding ? JSON.parse(cachedOnboarding) : null;

        // If no cached data or data seems stale, fetch from API
        if (!onboardingData) {
          const response = await api.get(`${baseURL}workspace/onboarding-data/`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          onboardingData = response?.data;
          dispatch(setOnboardingData(onboardingData));
          localStorage.setItem('onboardingData', JSON.stringify(onboardingData));
        }

        // If user is not onboarded, redirect to calendar-meeting for proper onboarding flow
        if (!onboardingData?.onboarded) {
          navigate('/calendar-meeting', { replace: true });
          return;
        }

        setLoading(false);
      } catch (error) {
        console.error('Error checking onboarding status:', error);
        // On error, redirect to calendar-meeting as fallback
        navigate('/calendar-meeting', { replace: true });
      }
    };

    if (accessToken) {
      checkOnboardingStatus();
    } else {
      navigate('/login', { replace: true });
    }
  }, [accessToken, navigate, dispatch]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <NavbarLoggedInNew 
        isDrawerOpen={isDrawerOpen} 
        setIsDrawerOpen={setIsDrawerOpen} 
        userRole={userRole} 
      />
      
      <Container maxWidth="xl" sx={{ mt: 4 }}>
        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{
          }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {userRole === "mentor" ? (
              <MenteeCardList />
            ) : (
              <MenteeDashboardCard />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Dashboard;
